<template>
	<v-card 
		outlined
	>
		<v-card-title 
			class = "pa-1 caption"
		>			
			<template 
				v-for = "(item_roi, idx_roi ) of info.field_coords[shape]"
			>				
				<v-chip 
					x-small
					:key="idx_roi"
					class  = "ml-1"
					:color = "item_roi.color"
				>  
						{{item_roi.text}} : {{ info.coords[item_roi.key] ? info.coords[item_roi.key] : '' }}  
					<!-- <span 
						v-show = "shape == 'rectangle'"
						class  = "mx-1"
					>					
						{{ info.coords[item_roi.key1] }}	
					</span> -->

				</v-chip>
			</template>
			<v-chip
				x-small
				v-show  = "scale.active"
				key 	= "scale"
				color   = "success"
			>
				{{ $ml.get('scale')}} : {{ scale.text }}
			</v-chip>
			<v-spacer></v-spacer>
			<v-btn
				x-small
				:color = "play_pause ? 'primary' : 'error'"
				@click = "play_and_pause()"
			>
				<v-icon
					x-small
				>
					{{ play_pause ? 'mdi-play' : 'mdi-pause' }}
				</v-icon>
			</v-btn>

			<v-menu offset-y bottom :close-on-content-click = "true"> 
	         	<template v-slot:activator = " { on: menu } ">
	          		<v-tooltip top>
	            		<template v-slot:activator = " { on:tooltip } ">          
				            <strong 
				                x-small 
				                v-on = "{...tooltip, ...menu}"    
				            >
		                		<v-icon
		                			v-show = "false"
		                  			color  = "primary"
		                  			v-text = "'mdi-vector-rectangle'"
		                		></v-icon>
		              		</strong> <!-- axis-arrow-lock -->
	            		</template>
	            		<span>
	              			Channel : {{ channel }}
	            		</span>
	          		</v-tooltip>
	        	</template>
	        	<v-list dense>
	            	<v-list-item-group dense>
	              		<template v-for = "(item_shape, index_shape) of list_shapes">
	                
	              			<v-list-item               
				                dense
				                v-bind:Key = "index_shape"
				                v-if       = "item_shape"           
				                @click     = "render_shape(item_shape.name)"
	              			>              
		                  		<v-list-item-content class="pa-0 ma-0">
		                    		<v-list-item-title> 
		                    			{{ item_shape.name }} 
		                    		</v-list-item-title>
		                  		</v-list-item-content>
	              			</v-list-item>
	              		</template>
	            	</v-list-item-group>
	          	</v-list>
	      	</v-menu>   
			<!-- vector-polygon  / vector-polyline /shape-polygon-plus -->
			<v-menu 
				bottom
				offset-y 
				:close-on-content-click = "true"
			> 
	         	<template v-slot:activator = " { on: menu } ">
	          		<v-tooltip 
	          			top
	          		>
	            		<template v-slot:activator = " { on:tooltip } ">          
				            <strong 
				                x-small 
				                v-on = "{...tooltip, ...menu}"    

				            >
		                		<v-icon

		                			class  = "mx-2"
		                  			:color = "$vuetify.theme.dark ? 'white' : 'black' "
		                  			v-text = "'mdi-monitor-multiple'"
		                		></v-icon>
		              		</strong> <!-- axis-arrow-lock -->
	            		</template>
	            		<span>
	              			Channel : {{ channel }}
	            		</span>
	          		</v-tooltip>
	        	</template>
	        	<v-list dense>
	            	<v-list-item-group dense>
	              		<template v-for = "(item_channel, index) of list_channels">
	                
	              			<v-list-item               
				                dense
				                v-bind:Key = "index"
				                v-if       = "item_channel"                   
				                @click     = "render_channel(item_channel.name)"
	                
	              			>              
		                  		<v-list-item-content class = "pa-0 ma-0">
		                    		<v-list-item-title> 
		                    			{{ item_channel.name }} 
		                    		</v-list-item-title>
		                  		</v-list-item-content>
	              			</v-list-item>
	              		</template>
	            	</v-list-item-group>
	          	</v-list>
	      	</v-menu>   
			<v-btn 
				x-small
				icon
				@click = "actions('close_modal')"
				class  = "mx-1 error"
				v-show = "is_to_clear"

			>				
				<v-icon
					small
					class = ""
					color = "white"
				>
					mdi-close
				</v-icon>
			</v-btn>
			<!-- -circle -->
			
		</v-card-title>
		<v-card-text
			class = "px-1 pb-0"
		>
			
			<v-data-table
				v-show 				= "false"
				dense		    
			    fixed-header
			    hide-default-footer
				class 	 			 = "elevation-5"
				:items 	 			 = "render_list"		    
			    :height 			 = "layout_height + 'px'"
			   	:loading 			 = "false"
				:headers 			 = "header_table"
			    item-key			 = "id"
				:options.sync 		 = "options"
			   	loading-text 		 = "Loading... Please wait"							   
			   	:server-items-length = "total"							    					    
			   	:footer-props 		 = "{
			   		showFirstLastPage 	: true,
			   		itemsPerPageOptions : [15, 30],
			   		showCurrentPage 	: true,
			   		itemsPerPageText 	: ''
			   	}"
			>
				<template v-slot:item.actions="{ item }" >
					<v-btn
						x-small
						color  = "error"
						@click = "actions('delete_sel', item)" 
					>
						<!-- @click="(item)" -->
						<v-icon
							x-small
							v-text = "'mdi-delete'"
						></v-icon>
					</v-btn>					
				</template>
			</v-data-table>	
		

			<div 
				id 	  = "content" 
				style = "	width 		: 100%; 
						 	height 		: 500px; 
						 	object-fit 	: fill; 
						 	position 	: relative;"
			>
				<video
			      :id           = "'video' + ID_notification"
			      v-show        = "show.video"
			      style         = "width:100%; height:100%; object-fit: fill; position: absolute; "
			      class         = "video-js"
			    ></video>
			    <!-- 93 -->
				<img 
					id 	   = "stream" 
					:src   = "$logos.no_signal"
					v-show = "show.img"
					style  = "	width 		: 100%; 
								height 		: 100%; 
								object-fit 	: fill; 
								position 	: absolute; 
								z-index 	: 0;"
				/>
				
				<!-- <canvas 
					id="roi" 
					style="width: 100%; height: 100%;  position: relative;"
				></canvas> -->
				<template v-for = "(item_point, idx_point) of render_draw_points">
		        	<canvas
			          	:id    = "'roi' + item_point.id"
			          	:style = "`position: absolute; zIndex: ${item_point.id + 1}; width:100%; height:100%; objectFit: fill;`"
		        	></canvas>
      			</template>
			</div>

		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<template
				v-for = "(item_option, idx_option) of info_options"
			>
				<v-tooltip top>
					<template v-slot:activator = "{ on }">
						
						<v-btn
							x-small
							:icon  = "item_option.icon ? true : false"
							@click = "actions(item_option.action)"
							:class = "`${item_option.color_btn} mx-1`"
							v-show = "item_option.enable"
							v-on   = "on" 
						>
							
							<v-icon
								x-small

								v-if   = "item_option.icon"
								:color = "item_option.color_icon"
							>
								{{ item_option.icon }}
							</v-icon>
							<span
								v-else-if = "item_option.text"
							>
								{{ item_option.text }}
							</span>
						</v-btn>				
					</template>
					<span>
						{{ $ml.get(item_option.tooltip) }}
					</span>
				</v-tooltip>
			</template>
			<v-btn
				x-small
				@click = "actions('show_advanced')"
				:color = "show_advanced ?  'secondary' : 'primary'"			
				v-show = "false"	
				
			>
			<!-- is_to_clear -->
				 {{ show_advanced ? 'hide' : 'Advanced' }}
			</v-btn>
			<v-spacer></v-spacer>
			<v-input			   
			    :success-messages = "[message]"					    
			></v-input>
			<v-btn
				x-small
				@click = "save"
				color  = "primary"
				v-show = "!loading && is_to_clear"
				class  = "mx-1"
				
			>
				{{ $ml.get(action_roi) }}
			</v-btn>
			<v-progress-circular
				v-show = "loading"
				color  = "primary"
				:size  = "20"
				class  = "mx-1"
				indeterminate
			></v-progress-circular>
			<v-btn
				x-small
				v-show = "is_to_clear"
				color  = "error"
				v-text = "$ml.get('close')"
				@click = "actions('close_modal')"
			></v-btn>
		</v-card-actions>
	</v-card>

</template>
<script>
	import EventBus from '@/event-bus'
	import videojs  from "video.js";
	import "video.js/dist/video-js.css"

	// Configurar VideoJS globalmente para desactivar logs
	// videojs.log.level('error'); // Esta función no existe en esta versión
	
	// Desactivar logs de VideoJS completamente
	videojs.log = () => {};
	videojs.log.error = () => {};
	videojs.log.warn = () => {};
	videojs.log.info = () => {};
	videojs.log.debug = () => {};
	
	export default{
		name: 'alarm_roi',
		props:[
			'info_to_component',
			'clear_to_component',
			'type_shape',
			'is_to_clear',
			'channel_analytic',			
			'action_to_component',
			'analytic_to_component'
		],
		data:() => ({

			/*
				cuadrado : * 
				polygonos: areas /  zonas of alerts

			*/
			info: {
				field_coords: {
					rectangle : [
						{
							key 	: "left", // left / X
							text 	: "Left",						
							color 	: "dark",
						},
						{
							key: "top", // top / Y
							text: "Top",
							color: "primary",
						},
						{
							key: "width",
							text: "Width",
							color: "success"
						},

						{
							key: "height",
							text: "Height",
							color: "info",
						},
					],
					polygon : [
						{
							key 	: "point1", // left / X
							text 	: "point1",						
							color 	: "dark",
						},
						{
							key: "point2", // top / Y
							text: "point2",
							color: "primary",
						},
						{
							key: "point3",
							text: "point3",
							color: "success"
						},

						{
							key: "point4",
							text: "point4",
							color: "info",
						}
					]
				},
				coords: {

					
				},
				
			},
			defaults_shape : {
				rectangle : {
					x: 0,
					y: 0,
					width: 0,
					height: 0,
				},
				polygon : [
					{}
					]
			},
			streaming: {},
			btn_save: {
				text: '',
				key: ''
			},

			info_options : [
				{
					action 		: 'delete_roi',
					color_btn 	: 'error',
					icon 		: 'mdi-square-off-outline',
					enable		: true,
					tooltip  	: 'delete_shape',
				},

				/*
				{
					action 		: 'add_roi',
					color_btn 	: 'primary',
					icon 		: 'mdi-shape-rectangle-plus',
				},
				*/
				{
					action 		: 'add_roi',
					color_btn 	: 'primary',
					icon 		: 'mdi-shape-polygon-plus',
					enable		: true,
					tooltip  	: 'new_shape',

				},
				{
					key 		: 'roi',
					action 		: 'roi',
					color_btn 	: 'error',
					// icon 		: 'mdi-shape-polygon-plus',
					text  		: 'roi',
					enable		: false,
					tooltip  	: 'roi',

				},
				{
					key 		: 'scale',
					action 		: 'scale',
					color_btn 	: 'secondary',
					text 		: 'scale',
					// icon 		: 'mdi-shape-polygon-plus',
					enable		: false,
					tooltip  	: 'scale',

				},
				{
					action 		: 'confirm_reset',
					color_btn 	: 'primary',
					btn 		: 'reset',
					icon 		: 'mdi-autorenew',
					enable		: false,
					tooltip  	: 'reset',

				},
				/*{
					action 		: 'close_modal',
					color_btn 	: 'error',
					icon   		: 'mdi-close',
					color_icon 	: 'white',
					enable		: false,
				}*/
			],
			options : { itemsPerPage : 30 },
			total 	: 0,
			list 	: [],
			layout_height : 100,
			header_table : [
				{
					text  : 'left',
					value : 'left',
				},
				{
					text  : 'top',
					value : 'top',
				},
				{
					text  : 'width',
					value : 'width',
				},
				{
					text  : 'height',
					value : 'height',
				},
				{
					text  : 'action',
					value : 'actions',
				},
			],
			action_roi  : 'save',
			default_roi : false,
			info_device : {},
			shape : 'polygon',
			channel 		: 'motion',
			list_channels   : [
		      {
		        name : 'motion'
		      },
		      {
		        name : 'basic'
		      },
		      {
		        name : 'face'
		      },
		      {
		        name : 'lpr'
		      },
		      {
		        name : 'hls', // retrans 
		      },
		      {
		        name : 'hls 2', // retrans 
		      },
		      {
		        name : 'snapshot'
		      }
		    ],
		    draw_points 	: [],
		    show_advanced 	: false,
		    show 			: {
		    	img 	: true,
		    	video 	: false,
		    }, 
		    list_shapes 	: [
		    	{
		    		name : 'polygon',
		    	},
		    	{
		    		name : 'rectangle',
		    	},
		    ],
		    idx_point 	: 0,
		    loading 	: false,
		    message 	: '',
		    scale		: {
		    	text   : '',
		    	active : false
		    },
		    play_pause : false,
		    bus 	   : {},
		    is_action  : '',
		    ID_notification : "alarm_roi",
		    video_setup       : {
		      	"liveui"  : true,
		      	autoplay  : true,
		      	controls  : true,
		      	// width     : "100%",
		      	// height    : "100%",
		      	// Desactivar logs de VideoJS completamente
		      	logLevel: 'error', // Solo mostrar errores críticos
		      	html5: {
		      		hls: {
		      			smoothQualityChange: true,
		      			enableLowInitialPlaylist: true,
		      			overrideNative: true,
		      		}
		      	},
		      	// Configuración adicional para silenciar logs
		      	suppressNotSupportedError: true,
		      	sources: [
		        	{
			          	src  : '/path/to/video.mp4',
			          	type : "application/x-mpegurl", //'video/mp4'
		        	}
		      	]
		    },
		    video_source      : "",
		    video_type        : "application/x-mpegurl",
		    player            : null,
		    video_listening   : null,
		    timer_out_limit_plate : null,
		    streamObjectURL: null,
		    snapshot_interval : null,
		}), // data
		watch:{

			info_to_component: function(val){
				this.$nextTick( () => {
					if (val) {
						this.render_info(val);
					}
				})
			},
			action_to_component : function(actions){
				
				console.log("action_to_component : ", actions);

				const { action , item } = actions;
				// coords, idx, title, color
				if (action == 'update'){
					if (this.draw_points && this.draw_points.length > 0 && this.draw_points[1]) {
						this.save();
					}else{
						console.log("Info default not update")
					}
				}
				if (action == 'update_rois') {
					let temp = item ;
					if (temp) {
							
						if (temp.points && temp.points.length > 0){
							this.shape = 'rectangle';
							// console.log("ROI : update rois", temp, this.draw_points);
							let coord_temp = {
									left   : temp.points[0][0],
									top    : temp.points[0][1],
									width  : temp.points[0][2],
									height : temp.points[0][3]
								}
							this.draw_points.push({
								id      : 0,
								polygon : [],
								rect 	: {},
								roi     : null,
								info 	: coord_temp,
								context : null,
								draw    : null,
								title 	: 'roi',
								color   : 'red',
							})
							if (this.draw_points && this.draw_points.length > 0 ) {
								
								// console.log("ROI : update coords scale ", temp);
								const timer = setTimeout (() => {
									this.start_draw_roi(coord_temp, 0, 'roi', 'red');
									
									if (temp && temp.info_scale) {
										// console.log('ROI SCALE : ', temp.info_scale)
										let temp_scale = temp.info_scale;
										if (this.draw_points && this.draw_points.length > 0 && this.draw_points[1]) {

										}else{
											
											const { left, top,  height, width } 	= temp.roi_scale ? temp.roi_scale : { 
												left : 0.0000, 
												top : 0.0000, 
												height : 0.0500
											};
											let temp_scale_roi = {
												left 	: left,
												top 	: top,
												width 	: width || temp_scale,
												height 	: height,
												scale 	: temp_scale,
											}
											this.actions('scale', temp_scale_roi)
										}

									}
									clearTimeout(timer);
								}, 100)  ;
							}
						}
					}
				} // update_rois
			}, // action to component

			/*clear_to_component : function(val){
				if (val){
					this.actions('clear_info');

				}	

			}, */// clear to component
		
		}, // watch

		created(){

			if ( this.info_to_component && this.info_to_component.deviceId) {
				this.$nextTick( () => {

					this.render_info(this.info_to_component);
				})
			}
			// console.log("setting Analytic ", this.$route.name)
			if (this.$route) {
				this.ID_notification += this.$route.name; 
				if (this.$route.name == 'setting_analytic') {
					this.info_options[0].enable = false;
					this.info_options[1].enable = false;
				}
			}

		}, // created

		computed : {

			render_list: function(){
				return this.list;
			}, // render list
			
			render_draw_points: function (){
				return this.draw_points;
			}, // render draw points
		
		}, // computed
		

		methods:{
			// 
			actions(act, item, opt){
				// console.log( "ACtion ROI : " , act)

				if ( act == 'close_modal') {
					this.actions('clear_info');					
					this.$emit('close', null);
				}
				if ( act == 'add_roi') {
					if (this.info && this.info.coords) {
						const coords = this.info.coords 
						this.list.push(coords);
						this.total ++;

						this.draw_points.push({
							id      : this.draw_points.length,
							polygon : [],
							context : null,
							draw    : null,

						})
						const timer_draw = setTimeout(()=>{
							this.start_draw_roi(null, this.draw_points.length - 1);
							clearTimeout(timer_draw);
						},100);

					}else{
						console.log("Not found coords to add ")
					}
				}
				if ( act == 'delete_sel' ) {
					this.list.splice(this.list.indexOf(item), 1);
					this.total --;
				}

				if ( act == 'delete_roi') {
					if (this.info && this.info.coords) {
						this.info.coords = {
							/*x 		: 0,
							y 		: 0,
							width 	: 0,
							height 	: 0,*/
						};
						if (this.idx_point >= 0) {
							let { context } = this.draw_points[this.idx_point];
							let w = this.info_roi.current_width;
							let h = this.info_roi.current_height;
							context.clearRect(0, 0, w, h);
							this.draw_points.splice(this.idx_point, 1);
						}
					}
				}

				if(act == 'show_advanced'){					
					let show = this.show_advanced
					this.show_advanced 			= !show;
					this.info_options[1].enable = !show;
				}

				if ( act == 'clear_info') {
					// console.log("clear info dialog roi")
					this.draw_points = [];
					this.list 		 = [];
					this.stop_snapshot_interval();
					EventBus.$emit('close_stream', this.info_device.deviceId );
				}

				if ( act == 'roi') {
					console.log("select roi")
					this.info_options[2].color_btn = 'error';
					this.info_options[3].color_btn = 'secondary';
					if (this.draw_points && this.draw_points.length > 0) {
						let temp = this.draw_points[0];
						/*const timer_draw = setTimeout(()=>{
							this.start_draw_roi(temp.info, 0, 'ROI', 'red');
							clearTimeout(timer_draw);
						},500);*/
						this.idx_point = 0;

					}
				}
				if ( act == 'scale') {
					this.info_options[3].color_btn = 'light-blue';
					this.info_options[2].color_btn = 'secondary';					
					if (this.draw_points && this.draw_points.length > 0 && this.draw_points[1]) {
						let temp = this.draw_points[1];
						this.idx_point = 1;
						/*const timer_draw = setTimeout(()=>{
							this.start_draw_roi(temp.info, 1, 'SCALE', 'blue');
							clearTimeout(timer_draw);
						},500);*/
					}else{
						let idx_coord = this.draw_points.length;
						let temp_coord = item ? item : null;
						this.draw_points.push({
							id      : idx_coord,
							polygon : [],
							rect 	: {},
							info 	: temp_coord,
							context : null,
							draw    : null,
							title 	: 'plate',
							key 	: 'scale',
							color   : 'blue',

						})
						// this.list.push({});
						// console.log(this.draw_points, " DRAW POINTS ADDED SCALE")
						const timer_draw = setTimeout(()=>{
							this.start_draw_roi(temp_coord , idx_coord, 'scale', 'blue');
							clearTimeout(timer_draw);
						},500);
					}
				}
				if ( act == 'confirm_reset') {
					this.is_action 	= 'reset';
					this.$EventBus.$emit('notifications_modal',{
						type : 'confirm_reset',
						ID 	 : 'alarm_roi'
					})
				}

				if (act == 'reset') {
					if (this.list_draws && this.list_draws.length > 0) {
						this.list_draws.splice(1)
						this.start_draw_roi(null, 0);
					}
				}

			}, // actions

			play_and_pause(){
				this.play_pause = !this.play_pause;
				if (this.channel.includes("hls")) {
					if (this.player) {

						if (this.player.paused()) {
							this.player.play();
						}else{
							this.player.pause();
						}
					}
				} else if (this.channel == 'snapshot') {
					// For snapshot, pause/resume the interval
					if (this.play_pause) {
						this.stop_snapshot_interval();
					} else {
						this.start_snapshot_interval();
					}
				}
			}, // play and pause

			video_pause(){
				if (this.player) {
					this.player.pause();
				}
			}, // video pause

			render_info(item){
				if (item && item.deviceId) {
					if (item.deviceId != this.info_device.deviceId ) {
						this.actions('clear_info');
					}
					this.info_device = item;					
					this.start_stream(item);
					
					if (this.channel_analytic) {
						this.render_channel(this.channel_analytic);
					}
					if (!this.default_roi) {
						let coords_temp = null;
						if (item.points) {
							coords_temp = item.points;
							if (item.id && item.points) {
								// coords_temp = item.points;//.points
								// console.log("START CHECK POINTS")
								if (coords_temp && coords_temp.length > 0) {
								// console.log("START run POINTS")

									coords_temp.forEach((temp_coord) => {
										try {

											if (typeof temp_coord.points === 'string') {
												temp_coord.points = JSON.parse(temp_coord.points);
												
												if (typeof temp_coord.points === 'string') {
													temp_coord.points = JSON.parse(temp_coord.points);
												}
											}		
										}catch(er){
											console.log("Error converting point  to draw : " , er)
										}
										console.log("for : *****************", temp_coord)								
									}); // forEach
								}

							}


							try{

								if (typeof coords_temp === 'string') {
									coords_temp = JSON.parse(coords_temp);
									if (typeof coords_temp === 'string') {
										coords_temp = JSON.parse(coords_temp);
										if (typeof coords_temp === 'string') {
											coords_temp = JSON.parse(coords_temp);
											if (typeof coords_temp === 'string') {
											coords_temp = JSON.parse(coords_temp);
											}
										}
									}
								}
							}catch(er){
								console.log("Error convert points", er);
							}
						} // if have points 
						// console.log("POINTS TEMP : ************** " , coords_temp);
						if (this.type_shape) {
							this.shape = this.type_shape
						}
						if (this.shape == 'polygon' && (coords_temp.width || coords_temp.height)) {
							coords_temp = null;

						}else if(this.shape == 'rectangle' ){
							this.info_options[0].enable = false;
							if (this.analytic_to_component == 'lpr') {
								this.info_options[2].enable = true;
								this.info_options[3].enable = true;							
							}
							if (!coords_temp) {
								coords_temp = null; //.push({width : null, height: null});
							} 

						}else{
							if (coords_temp && coords_temp.length > 0) {
								this.info.coords = coords_temp[coords_temp.length - 1];
							}
						}

						// console.log("alarm roi ", coords_temp)
						this.$nextTick( () => {
							if (coords_temp && coords_temp.length > 0) {
								coords_temp.forEach( (coord, idx_coord) => {								
									if (coord) {
										console.log("Add coord roi : ", coord);
										this.draw_points.push({
											id      : idx_coord,
											polygon : [],
											rect 	: {},
											info 	: coord && coord.id ? coord : null,
											context : null,
											draw    : null,
											title   : coord && coord.title ? coord.title : '',
											// title 	: idx_coord == 0 ? 'roi' : 'scale',
											color   : idx_coord == 0 ? 'red' : 'blue',
											key     : idx_coord == 0 ? 'roi' : 'scale',

										})

										if(coord && coord.points && coord.points){
											let defaultPolygon = [
												["0.0102", "0.016"],
												["0.9918", "0.016"],					
												["0.9918","0.984"],				
												["0.0102", "0.984"]		
											]
											let isConflict = false;
											for(let it in coord.points){
												if(coord.points[it][0] && (coord.points[it][0]==0 || coord.points[it][0]=="NaN" || coord.points[it][0]==NaN)){
													isConflict = true;
												}else if(coord.points[it][1] && (coord.points[it][1]==0 || coord.points[it][1]=="NaN") || coord.points[it][0]==NaN){
													isConflict = true;													
												}
												
											}
											if(isConflict){
												coord.points = defaultPolygon;
											}
											// coord.points = defaultPolygon;
										}
										// console.log("points ", coord)

										console.log(this.draw_points, " DRAW POINTS ADDED")
										const timer_draw = setTimeout(()=>{
											this.start_draw_roi(coord && coord.points ? coord.points : coord , idx_coord, coord && coord.title ? coord.title : null);
											clearTimeout(timer_draw);
										},500);
									}				
								}) 
							}else{
								if (this.shape == 'rectangle') {
									/*let coord = coords_temp;
									let idx_coord = this.draw_points.length === 0 ? 0 : this.draw_points.length; 
									this.list.push(coord)
									console.log(idx_coord,this.draw_points.length ,"**************************** RECT " )
									this.draw_points.push({
										id      : idx_coord,
										polygon : [],
										rect 	: {},
										roi     : null,
										info 	: coord && coord.id ? coord : null,
										context : null,
										draw    : null,
										title 	: 'ROI',
										color   : 'red',

									})
									console.log(this.draw_points, " DRAW POINTS ADDED")
									const timer_draw = setTimeout(()=>{
										this.start_draw_roi(coord && coord.points ? coord.points : coord , idx_coord, 'ROI', 'red');
										clearTimeout(timer_draw);
									},500);*/
								}
								console.log("Not found points to draw")
							}							
						})
					}
				}
			}, // render info

			render_channel(val){
		      	this.channel = val;
		       	if (val.includes("hls")) {
		       		this.show.img   = false;
      				this.show.video = true; 
      				// Stop snapshot interval if running
      				this.stop_snapshot_interval();
      				let temp    	= val.split(" ");        
			        try{
				        if (temp && temp.length > 1 ) {
				            this.video_setup.sources[0].src = this.$Format.format_local_hls({ ...this.info_to_component },  "hls", 2);
				        }else{
				            this.video_setup.sources[0].src = this.$Format.format_local_hls({ ...this.info_to_component },  "hls");
				        }
			          // console.log("TEMP ", temp, this.video_setup.sources[0].src)
			        }catch(er){
			          	// console.warn("Error set hls ", this.ID_notification , er)
			        }
			        this.$nextTick(()=>{

			          	let video             = document.getElementById('video' + this.ID_notification);			          
			          	this.player           = videojs(video, this.video_setup, this.video_listening = () => {
			            	// Desactivar logs de VideoJS
			            	this.player.log = () => {}; // Desactivar logs
			          	});

			        })

		       	}else if (val == 'snapshot') {
		       		this.show.img   = true;
	      			this.show.video = false; 
	      			this.video_pause();
	      			// Start snapshot fetching
	      			this.start_snapshot_interval();
		       	}else{
			       	this.show.img   = true;
	      			this.show.video = false; 
	      			this.video_pause();
	      			// Stop snapshot interval if running
	      			this.stop_snapshot_interval();
		       	}
		      /*this.$emit('update_of_component', { 
		        component : 'cam_test',
		        key       : 'channel',
		        value     : val,
		        ID        : this.layout_id,
		      });*/

		    }, // render channel

		    render_shape(val){
		    	this.shape = val;
		    }, //  render shape

			save(){
				// this.save_rect(x, y, w, h);
				console.log("start save")
				let vm 			= this;
				this.list.push(this.info.coords);
				const coords 	= this.list;//;
				console.log(coords, "COORDS ALARMS")
				// let list = [];
				// list.push(coords);
				// list = this.$Helper.get_local('devices_alarm');

				// if ( list && list.length > 0) {
					let search = this.info_device && this.info_device.deviceId ? this.info_device.deviceId : null;
					if (search) {
						console.log(this.info_device, this.info, "before save coords")
						
						/*const find = list.some( (dev) => {
							if (dev.deviceId == search){
								return true
							}
						})*/
						if (this.info_device && this.info_device.points && this.info_device.id && this.is_to_clear) {
							/*&& this.info_device.points.Detail_roi_device_alarmId*/

							console.log("UPDATE Detail points");

							if (this.draw_points && this.draw_points.length > 0) {
								// this.info_device.points
								let temp_points = this.draw_points;
								let temp_list 	= [];
								for(let point of temp_points) {
									console.log("to update point : ",point)
									if (point.info) {
										console.log(point.info.points, " convert points ")
										try{

										point.info.points = JSON.stringify(point.info.points);
										}catch(erj){
											console.log("Error parse json update-save points  : ", erj );
										}		
										console.log(point.info.points, " convert points 1")
										temp_list.push(point.info);
										const api  			= this.$URL + '/api/v1/alarm/roi/' + point.info.id;
										const res_update 	= this.$axios.put(api, point.info).then( res => {
											// this.$SmartEvent.set("list_points", point.info, this.info_device);
											console.log('updated roi ', point)
										console.log("update points global updated ",point);

										}).catch( er => {
											console.log("Error update points ",  er);
										})
									}/*else{
										const api = const api  = this.$URL + '/api/v1/alarm/roi/';
										let info_up = {
											points : JSON.stringify(point.polygon),
											state  : this.info_device.state,
											Detail_roi_device_alarmId : this.info_device.alarmId,
										};
										const res_create = await this.$axios.post(api, ).then( res => {
											console.log('create roi ', point.id)
											point.info.points = point.polygon;
										}).catch( er => {
											console.log("Error create points ",  er);
										})
									}*/
								}; // for
								console.log("close component roi")

								this.info_device.points = temp_list; //
								this.$emit('action_component',{
									act  : 'render_selecteds',								
	 								item : this.info_device,
	 								option : '',
								});
								
								if (this.is_to_clear) {									
									this.actions('close_modal');
								}
							}

						}else{
							this.info_device.points = coords;
							this.$emit('action_component',{
								act  : 'render_selecteds',								
 								item : this.info_device,
 								option : '',
							});

							this.message = this.$ml.get('updated');
								const timer = setTimeout(()=>{
									this.message = '';
									clearTimeout(timer);
								},2000)

							if (this.is_to_clear) {								
								this.actions('clear_info');
							}

						}

						/*this.$EventBus.$emit('notifications_modal', {
							type 	: 'saved',
							message : 'Points',
						})*/
					}else{
						console.log("deviceId not found its require for save points")
						this.$EventBus.$emit('notifications_modal', {
							type 	: 'error',
							message : 'Device Not found',
						})
					}
				// } // list
				// localStorage.setItem('points_device', JSON.stringify(list));
			}, // save

			start_stream(item){
					console.log("streaming",  item );
				// this.loading = true;
				if (this.streaming && this.streaming.device) {
					this.$EventBus.$off('stream' + this.streaming.device, this.streaming.bus);

				}

				this.streaming = {					
					device  : item.deviceId,
					bus 	: null,
				};
				
				let video_stream = document.getElementById('stream');
				
				// If snapshot channel, start snapshot interval instead of EventBus stream
				if (this.channel == 'snapshot') {
					this.start_snapshot_interval();
					return;
				}
				
				this.$EventBus.$emit('start_stream', item.deviceId);

				let sw = false;
				let sw1 = false;
				video_stream.src = this.$logos.no_signal; //"/img/no_signal.jpg";
				this.$EventBus.$on('stream' + item.deviceId, this.streaming.bus = (msg) =>{
					if (!sw) {	
						/*if (!sw1) {
							sw1 = true;
							this.loading = false;
						}	*/			
						if (msg.channel == this.channel && !this.play_pause) {
							
							const b64Data = msg.message;
							const contentType = 'image/jpeg';
							
							const blob = this.$Helper.base64ToBlob(b64Data, contentType);

							if (this.streamObjectURL) {
								URL.revokeObjectURL(this.streamObjectURL);
							}

							this.streamObjectURL = URL.createObjectURL(blob);
							video_stream.src = this.streamObjectURL;
							
							video_stream.onload = function () {
				                sw = false;
				            }
				            sw = true;
						}
					}
				});


			}, // start stream

			start_snapshot_interval(){
				// Clear any existing interval
				this.stop_snapshot_interval();
				
				// Fetch snapshot immediately
				this.fetch_snapshot();
				
				// Set interval to fetch every 10 seconds
				this.snapshot_interval = setInterval(() => {
					if (this.channel == 'snapshot' && !this.play_pause) {
						this.fetch_snapshot();
					}
				}, 10000);
			}, // start_snapshot_interval

			stop_snapshot_interval(){
				if (this.snapshot_interval) {
					clearInterval(this.snapshot_interval);
					this.snapshot_interval = null;
				}
			}, // stop_snapshot_interval

			async fetch_snapshot(){
				if (!this.info_device || !this.info_device.deviceId) {
					console.log("fetch_snapshot: No deviceId available");
					return;
				}
				
				try {
					// Build API URL - POST request to snapshot endpoint
					// The endpoint requires POST with deviceId in the body: {"deviceId": "device-id"}
					// Alternative: can use rtspUrl: {"rtspUrl": "rtsp://..."}
					// Note: this.$axios automatically includes Authorization header with Bearer token
					// configured in src/plugins/axios.js and src/main.js
					const api = this.$URL + '/api/v1/device/snapshot';
					const body = { deviceId: this.info_device.deviceId };
					
					// The endpoint returns JSON with base64, so use json responseType directly
					const res = await this.$axios.post(api, body, {
						responseType: 'json'
					});
					
					let video_stream = document.getElementById('stream');
					
					if (!video_stream) {
						console.log("fetch_snapshot: Element 'stream' not found");
						return;
					}
					
					if (res && res.data) {
						// Handle different response formats
						let imageData = null;
						
						if (res.data.base64) {
							// If response has base64 field (most common case)
							imageData = 'data:image/jpeg;base64,' + res.data.base64;
							console.log("fetch_snapshot: Image loaded from base64, length:", res.data.base64.length);
						} else if (res.data instanceof Blob) {
							// If response is a Blob (image)
							if (this.streamObjectURL) {
								URL.revokeObjectURL(this.streamObjectURL);
							}
							this.streamObjectURL = URL.createObjectURL(res.data);
							imageData = this.streamObjectURL;
							console.log("fetch_snapshot: Image loaded from Blob");
						} else if (typeof res.data === 'string') {
							// If response is directly a base64 string
							if (res.data.startsWith('data:')) {
								imageData = res.data;
							} else {
								imageData = 'data:image/jpeg;base64,' + res.data;
							}
							console.log("fetch_snapshot: Image loaded from string");
						}
						
						if (imageData) {
							video_stream.src = imageData;
							console.log("fetch_snapshot: Image src updated successfully");
						} else {
							console.log("fetch_snapshot: No imageData generated from response:", res.data);
							video_stream.src = this.$logos.no_signal;
						}
					} else {
						console.log("fetch_snapshot: No data in response");
						video_stream.src = this.$logos.no_signal;
					}
				} catch (er) {
					console.log("Error fetching snapshot: ", er);
					// On error, show no signal
					let video_stream = document.getElementById('stream');
					if (video_stream) {
						video_stream.src = this.$logos.no_signal;
					}
				}
			}, // fetch_snapshot

			get_local(){
				if (localStorage.getItem('Rois_device')){
					this.list_local = localStorage.getItem('Rois_device');

				}
				
			}, // get_local

			save_rect(x, y, w, h){
				let info_local 	= {x, y, w, h};
				let device;
				if (this.info_to_component && this.info_to_component.deviceId) {

					device = this.info_to_component.deviceId;

					if (this.list_local && this.list_local.length > 0) {

						this.list_local.push({info_local, device});
					}else{
						this.list_local = [{coords: info_local, device}];
					}

					const list 		= this.list_local;

					localStorage.setItem('Rois_device', JSON.stringify(list));
				}
				

				
			},

			start_draw_roi(coords, idx, title, color){
				console.log(coords , idx, "COORDS /IDX , START draw roi")
				let content		= document.getElementById('content');
				let roi 		= document.getElementById("roi" + idx);
				let streaming	= document.getElementById("stream");
				let stream 		= {};
				let roi_context;
				let current_width, current_height;
				let vm 			= this;

				vm.idx_point 	= idx;
				let text 		= title;

				// polygon
        		let nodeIndex 	= null;
    			let nodeRadius 	= 7;// 5
    			let context_point = null;
    			let polygon = [		           
		            /*[20, 20],
		            [150, 25],
		            [150, 289],
		            [50, 190]*/
		        ];

				if (roi.getContext("2d")) {
					console.log("Context success");


					current_width = roi.width  = streaming.getBoundingClientRect().width;
            		current_height = roi.height = streaming.getBoundingClientRect().height;

            		let init_pos_polygon = 4;

            		polygon = [
	            		[init_pos_polygon, init_pos_polygon],
			            [current_width - init_pos_polygon, init_pos_polygon],
			            [current_width - init_pos_polygon, current_height - init_pos_polygon],
			            [init_pos_polygon , current_height - init_pos_polygon]
		            ];


		            // context
					roi_context  = roi.getContext("2d");
					context_point =  roi_context;

					// rect 
					let mousedown, mouseup ,resized,
						drawing,
						dragging,
						drawed,
						draged,
						aux_left,
						aux_width,
						aux_height;
					let resizing = resized = drawing = dragging = drawed = draged = mousedown = false;
					let aux_top = aux_left = aux_width = aux_height = 0;
					let side;


					// colors and line
					// roi_context.lineWidth = 2; 

					let o    = Math.round, r = Math.random, s = 255;
		        	let ca   = 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ',0.5)';
			        let num1 = o(r()*s)
			        let num2 = o(r()*s)
			        let num3 = o(r()*s)
			        

					roi_context.strokeStyle = 'rgba('+num1+','+num2+','+num3+',0.5)';//'#ffffff';
		            roi_context.fillStyle 	= 'rgba('+num1+','+num2+','+num3+',0.3)';//'#00ff00';
		            roi_context.lineWidth 	= 3; // line width

					// set info of context and size
            		vm.info_roi = {
            			current_width,
						current_height,
						roi_context,
            		}

            		// set info draw points
            		console.log(vm.draw_points[idx], roi_context, "Contex / POints ")
					vm.draw_points[idx].context = roi_context;


					// draw default

					if (!vm.default_roi && coords && vm.shape == 'rectangle') {
						// vm.drawRect(roi_context, 2, 2, current_width - 4, current_height - 4);
						let width_temp = coords.width;
						/*if (coords.scale) {
							width_temp = roi.width * coords.scale;
						}*/
						if(!width_temp){
							width_temp = 0.1;
						}
						console.log("ROI , scale ", 							
							"X ",parseFloat(coords.left) , parseInt(roi.width), parseFloat(coords.left) * parseInt(roi.width) + '\n' , 
							"Y ",parseFloat(coords.top) , parseInt(roi.height),parseFloat(coords.top) * parseInt(roi.height)  + '\n' ,
							"W ",parseFloat(width_temp) , parseInt(roi.width),(parseFloat(width_temp) * parseInt(roi.width))  + '\n' ,
							"H ",parseFloat(coords.height) , parseInt(roi.height),(parseFloat(coords.height) * parseInt(roi.height))   + '\n' ,
							);

						vm.drawRect(roi_context,
							parseFloat(coords.left) * parseInt(roi.width), 
							parseFloat(coords.top) * parseInt(roi.height), 
							parseFloat(width_temp - coords.left) * parseInt(roi.width), 
							parseFloat(coords.height - coords.top) * parseInt(roi.height),
							vm.idx_point, text, color);

						stream.roi_left = aux_left =   parseFloat(coords.left) * parseInt(roi.width)//parseFloat(coords.left)
						stream.roi_top = aux_top =   parseFloat(coords.top) * parseInt(roi.height) //parseFloat(coords.top)
						stream.roi_width = aux_width  =  parseFloat(width_temp - coords.left) * parseInt(roi.width)//parseFloat(coords.width)
						stream.roi_height = aux_height =   parseFloat(coords.height - coords.top) * parseInt(roi.height)//parseFloat(coords.height)
						vm.setRelativeCoords(stream, roi, vm.idx_point);
					}else if(!vm.default_roi && !coords && vm.shape == 'rectangle'){
						vm.drawRect(roi_context, 2, 2, current_width - 4, current_height -4, vm.idx_point, text, color);
					}
					if (!vm.default_roi && coords && vm.shape == 'polygon'){
						if (coords.point1 || coords.point2){

							stream = coords;
							polygon = [
								[stream.point1[0] * roi.width , (stream.point1[1]) * roi.height],
								[stream.point2[0] * roi.width , (stream.point2[1]) * roi.height],
								[stream.point3[0] * roi.width , (stream.point3[1]) * roi.height],
								[stream.point4[0] * roi.width , (stream.point4[1]) * roi.height]
							];
							// console.log(stream.point1[1])
						}
						vm.drawPolygon(roi_context, polygon, nodeRadius, roi, vm.idx_point);

					}else if( !coords && vm.shape == 'polygon'){
						vm.drawPolygon(roi_context, polygon, nodeRadius, roi, vm.idx_point)
					}

					roi.addEventListener('mousedown', function(event){
						
						const mousePos 	= vm.getMousePos(roi, event);
						 side 	     	= vm.pointerIsInBorder(roi, mousePos.x, mousePos.y, stream); //camera = stream						
						if (vm.shape == 'rectangle') {
							
						    roi_context = vm.draw_points[vm.idx_point].context;
						    color = vm.draw_points[vm.idx_point] && 
						    		vm.draw_points[vm.idx_point].color ? 
						    		vm.draw_points[vm.idx_point].color : color;

							text  = vm.draw_points[vm.idx_point] && 
									vm.draw_points[vm.idx_point].title ? 
									vm.draw_points[vm.idx_point].title : text; 

							stream 	= vm.draw_points[vm.idx_point].rect;
							// roi 	= vm.draw_points[vm.idx_point].draw;

							if(side == "body"){

								if(roi_context.isPointInPath(mousePos.x, mousePos.y)){				
									dragging = true;
								}else{
									drawing = true;
								}
							}else{
								resizing = true;
							}			
							aux_left 	 = mousePos.x;
							aux_top  	 = mousePos.y;		
						}

						

						// polygon
						if (vm.shape == 'polygon') {
							// console.log("side *****************+ ",side , mousePos, current_width. current_height, roi)
							let find = false;
							let dx, dy, x, y, d; 
				            for (let index in polygon) {
				                x  = polygon[index][0];
				                y  = polygon[index][1];
				                dx = Math.abs(mousePos.x -x/*event.clientX - roi.offsetLeft - x*/);
				                dy = Math.abs(mousePos.y -y/*event.clientY - roi.offsetTop - y*/);
				                d  = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
				                if (d < nodeRadius) {
				                	// console.log(d , "NODE RADIUS")
				                	find = true;
				                    nodeIndex = index;				                    
				                    break;
				                }
				            }	
				            // console.log(d , "NODE RADIUS", find)
				            /*.left
							.right
							.middle*/
				            if (!find) {

								vm.draw_points.some( (poly, idx_poly) =>{
									// let dx, dy, x, y, d; 
									console.log("check point", poly)
						            polygon = poly.polygon;						                    
						            for (let index in poly.polygon) {
						                x  = polygon[index][0];
						                y  = polygon[index][1];
						                dx = Math.abs(mousePos.x -x/*event.clientX - roi.offsetLeft - x*/);
						                dy = Math.abs(mousePos.y -y/*event.clientY - roi.offsetTop - y*/);
						                d  = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
						                if (d < nodeRadius) {
						                	console.log(d , "NODE RADIUS 2")
						                    nodeIndex = index;
						                    vm.idx_point = idx_poly;
						                    context_point = poly.context;
						                    return true;
						                    break;
						                }
						            }	
								})
				            }
						} // polygon
					}, false);


					roi.addEventListener('mousemove', function(event){
						let top, left;
						let mousePos = vm.getMousePos(roi, event);						
						if (vm.shape == 'rectangle') {							
							// vm.is_draw_plate_in_limit(stream, roi, idx)

							if(dragging){				
								draged 		= true;
								left 		= parseInt(stream.roi_left) + (mousePos.x - aux_left);
								top 		= parseInt(stream.roi_top)  + (mousePos.y - aux_top);				

								if(left < 0){
									left = 0;
								}
								if(parseInt(stream.roi_width) + left  > roi.width){
									left = roi.width - parseInt(stream.roi_width);
								}			
								if(top < 0){
									top = 0;
								}
								if(parseInt(stream.roi_height) + top  > roi.height){
									top  = roi.height - parseInt(stream.roi_height);
								}
								vm.drawRect(roi_context, left, top, parseInt(stream.roi_width), parseInt(stream.roi_height), vm.idx_point, text, color);
							}

							if(drawing){				
								drawed 	   	= true;
								left  		= Math.min(aux_left, mousePos.x);
								top     	= Math.min(aux_top, mousePos.y);
								aux_width	= Math.abs(mousePos.x - aux_left);
								aux_height 	= Math.abs(mousePos.y - aux_top);	
								vm.drawRect(roi_context, left, top, aux_width, aux_height, vm.idx_point, text, color);
							}

							if(resizing){				
								resized = true;

								if(side == "top"){
									stream.roi_height 	= stream.roi_height - (mousePos.y - stream.roi_top);
									stream.roi_top 		= mousePos.y;
								}

								if(side == "bottom"){
									stream.roi_height = stream.roi_height - ((stream.roi_height + stream.roi_top) - mousePos.y);						
								}

								if(side == "left"){
									stream.roi_width = stream.roi_width - (mousePos.x - stream.roi_left);
									stream.roi_left  = mousePos.x;
								}

								if(side == "right"){
									stream.roi_width = stream.roi_width - ((stream.roi_width + stream.roi_left) - mousePos.x);
								}

								vm.drawRect(roi_context, stream.roi_left, stream.roi_top, stream.roi_width, stream.roi_height, vm.idx_point, text, color);
								vm.setRelativeCoords(stream, roi, vm.idx_point);
							}
							if(!drawing && !dragging && !resizing){
								vm.pointerIsInBorder(roi, mousePos.x, mousePos.y, stream);
							}
							
						}
						if (vm.shape == 'polygon') {
							if (nodeIndex != null) {
								roi_context = context_point;
				                roi_context.clearRect(0, 0, current_width, current_height);
				                polygon[nodeIndex][0] = mousePos.x; // event.clientX;
				                polygon[nodeIndex][1] = mousePos.y; //event.clientY;

				                vm.drawPolygon(roi_context, polygon , nodeRadius, roi, vm.idx_point);
				            }
						}
					}, false);

					roi.addEventListener('mouseup', function(event){
						
						let mousePos = vm.getMousePos(roi, event);

						resizing = drawing = dragging = false;
						if (vm.shape == 'rectangle') {
							// vm.is_draw_plate_in_limit(stream, roi, idx)

							if(drawed){				
								stream.roi_top    = parseInt(Math.min(aux_top, mousePos.y));
								stream.roi_left   = parseInt(Math.min(aux_left, mousePos.x));
								stream.roi_width  = parseInt(Math.abs(mousePos.x - aux_left));
								stream.roi_height = parseInt(Math.abs(mousePos.y - aux_top));		
								drawed 			  = false;
								vm.setRelativeCoords(stream, roi, vm.idx_point);
							}
							if(draged){
								stream.roi_left   = parseInt(stream.roi_left) + (mousePos.x - aux_left);
								stream.roi_top    = parseInt(stream.roi_top)  + (mousePos.y - aux_top);

								if(parseInt(stream.roi_left) < 0){
									stream.roi_left = 0;
								}
								if(parseInt(stream.roi_width) + parseInt(stream.roi_left)  > roi.width){
									stream.roi_left = roi.width - parseInt(stream.roi_width);
								}			
								if(parseInt(stream.roi_top) < 0){
									stream.roi_top = 0;
								}
								if(parseInt(stream.roi_height) + parseInt(stream.roi_top)  > roi.height){
									stream.roi_top  = roi.height - parseInt(stream.roi_height);
								}
								draged 			  = false;
								vm.setRelativeCoords(stream, roi, vm.idx_point);
							}
							if(resized){				
								resized 		  = false;				
								vm.setRelativeCoords(stream, roi, vm.idx_point);
							}			
						} // rectangle
						if (vm.shape == 'polygon') {
							nodeIndex = null;
						}
					}, false);

					
				}else{
					this.$EventBus.$emit('notifications_modal', {
						type: 'warning',
						message: 'Unsupported browser to draw area of interest'
					})
				}
			}, // start draw roi

			is_draw_plate_in_limit(stream, roi, idx){
				let vm = this;
				if (vm.draw_points && vm.draw_points.length > 0 && vm.draw_points[vm.idx_point] && vm.draw_points[idx].key == 'scale') {	
					
					let scale_limit = Math.abs(parseFloat((((stream.roi_width + stream.roi_left) / roi.width).toFixed(4) - vm.info.coords.left).toFixed(4)));
					console.log("LIMIT ", scale_limit)
					if (scale_limit <= 0.20) {
						return true;
					}else{
						return false;
					}
					
				}else{
					return true
				}
			}, // is_draw_plate_in_limit

			drawRect(context, x, y, w, h, idx, text = 'title', color ){			
				// console.log("DRAW : ", context, x, y, w, h)
				context.clearRect(0, 0, context.canvas.width, context.canvas.height);
				context.beginPath();
				/*if (!vm.change_roi) {
				}else{
					context.strokeStyle = 'red';

				}*/
				context.strokeStyle = 'white';				

				if (color == 'blue') {					
					context.fillStyle 	= 'rgba(30, 139, 195, 0.5)'; //'rgba(218, 148, 156, 0.5)';
				}else{
					context.fillStyle 	= 'rgba(240, 52, 52, 0.5)'
				}
				context.lineWidth	= 3;
				context.rect(parseInt(x), parseInt(y), parseInt(w), parseInt(h));
				// if (vm.draws[0]) {
				// 	context.rect(vm.draws[0].x, vm.draws[0].y, vm.draws[0].w, vm.draws[0].h);
				// }
				context.fill();
				context.stroke();

				context.font      = "16px Georgia";
                context.fillStyle = "rgba(0,0,0,1)";
                
                context.fillText(this.$ml.get(text),   x + 5, y + 15, 70);
                this.draw_points[idx].context = context;
                if ((idx || idx === 0) && this.draw_points && this.draw_points.length > 0 && this.draw_points[idx]) {
                }else{
                	console.log("Not found index of rect : ", idx);
                }
				
			}, // drawRect

			drawPolygon(ctx, poly, nodeRadius, roi, idx){

				
				this.draw_points[idx].polygon = poly;
				
	            ctx.beginPath();

	            let x, y;
	            for (let index in poly) {
	                x = poly[index][0];
	                y = poly[index][1];
	                ctx.lineTo(x, y);
	            }

	            ctx.closePath();
	            ctx.stroke();
	            ctx.fill();
	           	let temp_fill = ctx.fillStyle,
	           		temp_stroke = ctx.strokeStyle;

	            for (let index in poly) {
	                x = poly[index][0];
	                y = poly[index][1];
	                ctx.beginPath();
	                ctx.fillStyle 	= '#ffffff'
					ctx.strokeStyle = '#00ff00'
	                ctx.arc(x, y, nodeRadius, 0, Math.PI * 2, 1);
	                ctx.fill();

	                ctx.font      = "16px Georgia";
	                ctx.fillStyle = "rgba(0,0,0,1)";	                
	                const point_letter = index == 0 ? "A" : index == 1 ? "B" : index == 2 ? "C" : "D";
	                ctx.fillText(point_letter,x - 5, y + 5, 10); //  70

	            }
	            ctx.fillStyle 	= temp_fill;
				ctx.strokeStyle = temp_stroke;

	            this.setRelativeCoords(poly, roi, idx);
			}, // drawPolygon

			getMousePos(canvas, evt) {
			    let rect = canvas.getBoundingClientRect();
			    // console.log(rect, 'rect')
			    return {
			        x: parseInt((evt.clientX - rect.left) / (rect.right - rect.left) * canvas.width),
			        y: parseInt((evt.clientY - rect.top) / (rect.bottom - rect.top) * canvas.height)		        
		    	};
			}, // getMousePos

			pointerIsInBorder(canvas, x, y, viewer){
				let tol_x = 0;
				let tol_y = 0;			

				if((x >= parseInt(viewer.roi_left) - tol_x) && ( x <= parseInt(viewer.roi_left) + tol_x) && ( y >= parseInt(viewer.roi_top)) && (y <= parseInt(viewer.roi_top) + parseInt(viewer.roi_height))){
					canvas.style.cursor = "col-resize";
					return "left";
				}

				if((x >= parseInt(viewer.roi_width) + parseInt(viewer.roi_left) - tol_x) && (x <= parseInt(viewer.roi_width) + parseInt(viewer.roi_left) + tol_x) && ( y >= parseInt(viewer.roi_top)) && (y <= parseInt(viewer.roi_top) + parseInt(viewer.roi_height))){
					canvas.style.cursor = "col-resize";
					return "right";
				}

				if((y >= parseInt(viewer.roi_top) - tol_y) && ( y <= parseInt(viewer.roi_top) + tol_y) && ( x >= parseInt(viewer.roi_left)) && (x <= parseInt(viewer.roi_left) + parseInt(viewer.roi_width))){
					canvas.style.cursor = "ns-resize";
					return "top";
				}

				if((y >= parseInt(viewer.roi_height) + parseInt(viewer.roi_top) - tol_y) && (y <= parseInt(viewer.roi_height) + parseInt(viewer.roi_top) + tol_y) && ( x >= parseInt(viewer.roi_left)) && (x <= parseInt(viewer.roi_left) + parseInt(viewer.roi_width))){
					canvas.style.cursor = "ns-resize";
					return "bottom";
				}

				canvas.style.cursor = "default";
				return "body"

			}, // pointer is in border


			// this info its for save and show in view
			setRelativeCoords(stream, roi, idx){
				// console.log("set relative position")

				if (stream && roi) {
					if (this.shape == 'rectangle') {
						/*console.log("SCALE ROI : ", 
							"STREAM : "    , stream, 
							"ROI Width:  " , roi.width, 
							"ROI Height:  " ,roi.height)*/
						this.info.coords 		= {};
						this.info.coords.left	= (stream.roi_left / roi.width).toFixed(4);   //  clientLeft
						this.info.coords.top 	= (stream.roi_top / roi.height).toFixed(4);   //  clientTop
						this.info.coords.width	= Math.abs(((stream.roi_width + stream.roi_left) / roi.width).toFixed(4));	   // (stream.roi_left + 		  clientWidth
						this.info.coords.height	= Math.abs((( stream.roi_height + stream.roi_top) / roi.height).toFixed(4));   //   stream.roi_top + clientHeight
						/*this.info.coords.roi = {
							w : Math.abs(((stream.roi_width) / roi.width).toFixed(4)),
							h : Math.abs((( stream.roi_height) / roi.height).toFixed(4))
						}*/
						// console.log("SCALE ROI : " + idx , this.info.coords);
						if (this.draw_points && this.draw_points.length > 0 && this.draw_points[idx]) {							
							// if (this.draw_points[idx].info) {

							// }	
							// console.log(this.draw_points[idx], "SCALE")
							this.scale.active = false;
							if (this.draw_points[idx].key == 'scale') {
								// console.log("SCALE : ", roi, stream)
								//this.info.coords.width;
								this.info.coords.scale = Math.abs(parseFloat(
									(((stream.roi_width + stream.roi_left) / roi.width).toFixed(4) - this.info.coords.left).toFixed(4)));
								this.scale.active = true;
								if (this.info.coords.scale > 0.20) {
									if (!this.timer_out_limit_plate) {

										this.$EventBus.$emit("notifications_modal",{
											type 	: "warnining_dialog",
											message : this.$ml.get("plate_outside_allowed"),
											ID 		: this.ID_notification + '_limit_plate', 
										});
										this.timer_out_limit_plate = setTimeout(()=>{											
											clearTimeout(this.timer_out_limit_plate);
											this.timer_out_limit_plate = null;									
										},7000)
										// this.info.coords.scale = 0.20;
									} 

								}
								this.scale.text   = this.info.coords.scale;
								this.scale.coords = this.info.coords;
							}

							this.draw_points[idx].info 	= this.info.coords;
							this.list[idx] 				= this.info.coords;
							this.draw_points[idx].rect 	= stream;
							this.draw_points[idx].draw  = roi;
						}else{
							console.log("No found index draws : ", idx)
						}
					}else
					if (this.shape == 'polygon') {
						this.info.coords = {};
						this.info.coords.point1 = [(stream[0][0] / roi.width).toFixed(4) , 
						 		(stream[0][1] / roi.height).toFixed(4)];
						this.info.coords.point2 = [ (stream[1][0] / roi.width).toFixed(4) , 
								(stream[1][1] / roi.height).toFixed(4) ];
						this.info.coords.point3 = [(stream[2][0] / roi.width).toFixed(4) , 
								(stream[2][1] / roi.height).toFixed(4) ];
						this.info.coords.point4 = [ (stream[3][0] / roi.width).toFixed(4) , 
								(stream[3][1] / roi.height).toFixed(4) ];


						if (this.draw_points[idx].info) {
							this.draw_points[idx].info.points = this.info.coords;
						}								
						
					}



					/*console.log(
						"STREAM LEFT : " 		+ stream.roi_left,
						"\n STREAM TOP  : " 	+ stream.roi_top, 
						"\n STREAM Width : " 	+ stream.roi_width,
						"\n STREAM height : " 	+ stream.roi_height,
						"\n ROI Width  : " 		+ roi.width, 
						"\n ROI height  : " 	+ roi.height,
						
						this.info.coords, " ============ ROI")*/
				}
			
				// vm.roi.scale=

				// primero generar dos cuadros
				// segundo cuadro scale

				/* ancho*
                //scale 1
                48/ancho  */

			}, // set RelativeCoords

			
		}, // methods

		mounted(){
			// this.start_draw_roi();
			let temp_bus = 'notifications_modal' + this.ID_notification;
			this.$EventBus.$on(temp_bus, this.bus[temp_bus] = (action)=>{
				if (this.is_action == 'reset' && action) {
					this.actions('reset');
				}
			});

			// let temp_bus2 = "notifications_modal" + this.ID_notification + '_limit_plate';
			// this.$EventBus.$on(temp_bus2, this.bus[temp_bus2] = (action)=>{
				
			// });
		}, // mounted


		beforeDestroy(){
			// Combined cleanup from both hooks
			
			// Original cleanup
			this.$Helper.clear_bus(this.$EventBus, this.bus, 'alarm roi');
		    if (this.video_listening) {
		    	this.video_listening = null;
		    }

			// My added cleanup
			// Revoke the object URL to prevent memory leaks
			if (this.streamObjectURL) {
				URL.revokeObjectURL(this.streamObjectURL);
			}

			// Clean up the EventBus listener for the stream
			if (this.streaming && this.streaming.device) {
				this.$EventBus.$off('stream' + this.streaming.device, this.streaming.bus);
			}

			// Dispose the video.js player (if it exists)
			if (this.player) {
		      this.player.dispose();
		    }

			// Stop snapshot interval
			this.stop_snapshot_interval();
		}, // beforeDestroy

	};
</script>